import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=70e23d1e&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=70e23d1e&prod&lang=scss&scoped=true"
import style1 from "./Balance.vue?vue&type=style&index=1&id=70e23d1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e23d1e",
  null
  
)

export default component.exports